import { PharmacyListItem } from '../../../../services/pharmacy/pharmacy.model';
import { pharmacyRequestTableRow } from './admin-pharmacies-list.model';

function toPharmacyTableRows(pharmacies: PharmacyListItem, isArabic: boolean): pharmacyRequestTableRow {
  return {
    id: pharmacies.id,
    nickName: pharmacies.nickName.length > 25 ? pharmacies.nickName.slice(0, 25) + '....' : pharmacies.nickName,
    pharmacyOwner: pharmacies.pharmacyOwner.fullName,
    statusId: pharmacies.status.id,

    status: { titleAr: pharmacies.status.titleAr!, titleEn: pharmacies.status.titleEn! },
    assignedTo: pharmacies.assignedTo?.fullName || '',
    createdOn: pharmacies.createdOn,
    createdBy: pharmacies.createdBy?.fullName || '',
    lastModifiedOn: pharmacies.lastModifiedOn,
    lastModifiedBy: pharmacies.lastModifiedBy?.fullName || '',
  };
}

export function toPharmacyTableRowsList(pharmacies: PharmacyListItem[], isArabic: boolean): pharmacyRequestTableRow[] {
  return pharmacies.map((pharmacy) => toPharmacyTableRows(pharmacy, isArabic));
}
